import { Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { TranslationService } from "src/app/translation.service";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";

import { DataService } from "./../../data.service";
import { GUID } from "./../../guid";
import { AppConfig } from "./../../config";
import { MatDialog } from "@angular/material";

@Component({
  selector: 'app-objectselect',
  templateUrl: './objectselect.component.html',
  styleUrls: ['./objectselect.component.scss']
})
export class ObjectselectComponent implements OnInit {

  @Input() metaobjectid: string;
  @Input() objectname: string;


  detailForm = this.fb.group({

    objectid: "",
    objectname: "",
    object: "",

  });

  isLoading = false;
  isError = false;
  errorMessage = "";
  parentObjects: Array<any>;


  constructor(    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastrService: ToastService,
    private appConfig: AppConfig,
    private translationService: TranslationService,
    public dialog: MatDialog) { }

  ngOnInit() {


    this.getActiveObjectsByType().then((res) => {
      console.log("response11111", res);
      console.log("parentobjects", this.parentObjects);

      //this.detailForm.controls.parentobject.patchValue('');

      // if (this.mode.toLowerCase() == "edit") {
      //   // this.getMetaobjectById();
      // }
    });
  }


  parentObjectChange(event: { value: string; label: any }) {
    console.log("parentObjectChange", event);
    if (event.value.trim() != "") {
      this.detailForm.controls["objectid"].setValue(event.value);
      this.detailForm.controls["objectname"].setValue(event.label);

      this.metaobjectid = event.value
      this.objectname = event.label

    } else {
      this.detailForm.controls["objectid"].setValue("");
      this.detailForm.controls["objectname"].setValue("");
    }
  }


  getActiveObjectsByType() {
    return new Promise((resolve, reject) => {
      console.log("getActiveObjectsByType");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metaobject: {
            objecttype: "Domain",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveObjectsByType(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            var activeObjects = res.data.metaobjects;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < activeObjects.length; i++) {
              objArr.push({
                value: activeObjects[i].id,
                label: activeObjects[i].name,
              });
            }
            this.parentObjects = objArr;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

}
